import { Routes } from '@angular/router';

const title = 'Publicaciones';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [

   {
    path: 'vista',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Encontrados' }] },
        loadComponent: () => import('./pages/encontrado-lista/encontrado-lista.component'),
      },
    
    ],
  },

  
];
